<script setup>
import VueApexCharts from 'vue3-apexcharts';

// 사주풀이>오행분포 바 차트

const props = defineProps({
  fiveChardData: Object,
  fiveChardDesc: String,
  isMobile: Boolean,
  isPersonal: {
    type: Boolean,
    default: false,
  },
});

const categories = ['목', '화', '토', '금', '수'];
const customLabels = ['목 木', '화 火', '토 土', '금 金', '수 水'];

// 오행별 색상 (Figma 디자인 기준)
const fiveElementColors = {
  목: '#5e9f1c',
  화: '#c23535',
  토: '#db9823',
  금: '#949494',
  수: '#404040',
};

// 바 차트 데이터 (퍼센트)
const barData = computed(() => {
  return categories.map((key) => ({
    x: key,
    y: props.fiveChardData?.[key] ?? 0,
    fillColor: fiveElementColors[key],
  }));
});

const series = computed(() => [{ name: '타고난 오행', data: barData.value }]);

const labelColors = computed(() => categories.map((key) => fiveElementColors[key] || '#000'));

const chartOptions = computed(() => ({
  chart: {
    type: 'bar',
    toolbar: { show: false },
    zoom: { enabled: false },
    parentHeightOffset: 0,
    width: '100%',
  },
  plotOptions: {
    bar: {
      horizontal: false,
      borderRadius: 8,
      borderRadiusApplication: 'end',
      columnWidth: '28px',
      distributed: true,
      dataLabels: {
        position: 'top',
      },
    },
  },
  dataLabels: {
    enabled: true,
    offsetY: -20,
    style: {
      colors: labelColors.value,
      fontSize: '12px',
      fontWeight: 700,
      fontFamily: 'Pretendard',
    },
    background: {
      enabled: false,
    },
    formatter: (val) => `${val}%`,
  },
  colors: categories.map((key) => fiveElementColors[key]),
  xaxis: {
    categories: customLabels,
    axisTicks: { show: false },
    axisBorder: { show: false },
    labels: {
      style: {
        colors: labelColors.value,
        fontFamily: 'Pretendard',
        fontSize: '14px',
        fontWeight: '500',
      },
    },
  },
  yaxis: {
    opposite: false,
    min: 0,
    forceNiceScale: true,
    tickAmount: 4,
    labels: {
      padding: 8,
      style: {
        colors: ['#333'],
        fontSize: '12px',
        fontFamily: 'Pretendard',
      },
      formatter: (val) => Math.round(val),
    },
  },
  legend: {
    show: false,
  },
  grid: {
    borderColor: '#ebebeb',
    strokeDashArray: 0,
    padding: {
      top: 4,
      bottom: 8,
      left: 0,
      right: 0,
    },
  },
  tooltip: {
    enabled: true,
    y: {
      formatter: (val) => `${val}%`,
    },
  },
}));
</script>

<template>
  <div class="five-chart__wrapper" :class="[{ mobile: isMobile }]">
    <div class="chart-container">
      <VueApexCharts type="bar" height="250" :options="chartOptions" :series="series" />
    </div>
    <div class="five-chart__legend">
      <span class="legend-marker"></span>
      <span class="legend-text">타고난 오행</span>
    </div>
  </div>
</template>

<style scoped lang="scss">
.five-chart__wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0;

  &.mobile {
    gap: 0;
  }
}

.chart-container {
  width: 100%;
  max-width: 552px;
  margin: 0 auto;
  overflow: hidden;
}

.chart-container :deep(.apexcharts-canvas) {
  max-width: 100% !important;
  width: 100% !important;
}

:deep(.apexcharts-data-labels text) {
  stroke: white;
  stroke-width: 2px;
  paint-order: stroke;
}

:deep(.apexcharts-tooltip) {
  border-radius: 5px;
}

:deep(.apexcharts-gridlines-horizontal line) {
  stroke: #ebebeb;
}

.five-chart__wrapper .five-chart__legend {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;

  .legend-marker {
    width: 22px;
    height: 12px;
    background: #c23535;
    border-radius: 8px 8px 0 0;
  }

  .legend-text {
    color: #333;
    font-family: Pretendard;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
  }
}
</style>
